export const PLAY_STORE_URL = "https://play.google.com/store/apps/details?id=com.smit.smitprint";
export const APP_STORE_URL = "https://apps.apple.com/in/app/printanywhere/id6745421865";

const ua = () => (typeof navigator !== "undefined" ? navigator.userAgent || "" : "");

export function isAndroid() {
  return /android/i.test(ua());
}

export function isIOS() {
  if (/iPad|iPhone|iPod/.test(ua())) return true;
  // iPadOS 13+ reports itself as a Mac but has touch support.
  return typeof navigator !== "undefined" && navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1;
}

export function isMobile() {
  return isAndroid() || isIOS();
}

/** Store link for this device, or null on desktop. */
export function storeUrlForDevice() {
  if (isAndroid()) return PLAY_STORE_URL;
  if (isIOS()) return APP_STORE_URL;
  return null;
}

/**
 * Android -> Play Store, iPhone/iPad -> App Store. Returns false on desktop so the caller
 * can show the "get the app" page with both badges and a QR code instead.
 */
export function openStore() {
  const url = storeUrlForDevice();
  if (!url) return false;
  window.location.href = url;
  return true;
}
